export default {
  addToCart: 'إضافة إلى السلة',
  back: 'رجوع',
  cancelChanges: 'إلغاء التغييرات',
  chooseExpDate: 'اختر تاريخًا',
  date: 'التاريخ',
  endDate: 'تاريخ الانتهاء',
  experienceType: 'النوع',
  experienceVibe: 'الأجواء',
  filterExpDate: 'تصفية حسب التاريخ',
  filterExperienceType: 'تصفية حسب النوع',
  filterExperienceTypeScreenReader:
    'استخدم هذه المرشحات لتضييق نطاق النتائج. يتم تحديث المحتوى تلقائيًا عند اختيار أحد المرشحات.',
  filterExperienceVibe: 'تصفية حسب الأجواء',
  next: 'التالي',
  noExperiences: 'لا توجد تجارب',
  previous: 'السابق',
  proceedToCheckout: 'المتابعة إلى الدفع',
  removeFromReservation: 'إزالة من الحجز',
  saveChanges: 'حفظ التغييرات',
  search: 'بحث',
  selectDate: 'اختر التاريخ',
  startDate: 'تاريخ البدء',
  submit: 'إرسال',
  viewCalendar: 'التقويم',
};
